/*
 props:
  qid:
 * ctqa: {
 *  id:
 *  duration:
 *  name
 * }
 * exam: 考试名字
 * */
import React, { Component } from 'react';
import { withRouter } from 'react-router'
import config from 'config';
import { formatTime } from 'common/utils';
import style from './explainByTtile.css';

@withRouter
export default class ExplainByTitle extends Component {
  clickLook () {
    const query = this.props.location.query || {};
    let url = `${config.site.zhike}/play/${this.props.qid}.html?ctqaType=question&startTip=${this.props.tipId > -1 ? this.props.tipId : 0}`;
    if (query.online !== '1') {
      let domain = config.site.smart
      const userGroup = this.props.userGroup
      const userGroupName = this.props.userGroupName

      if (userGroup !== 1 && userGroupName) {
        if (process.env.NODE_ENV === 'production') {
          domain = domain.replace('//sp.smartstudy', `//${userGroupName}.smartxue`);
        } else {
          domain = domain.replace('//sp', `//${userGroupName}.yun`);
        }
      }
      url = `${domain}/play?sliceId=${this.props.ctqa.id}&type=ctqa${this.props.tipId > -1 ? `&tipId=${this.props.tipId}` : ''}`;
    }
    window.open(url);
  }

  render() {
    const ctqa = this.props.ctqa || {};
    if(ctqa.id) {
      return (
        <div>
          <p className={style.ctqaTitle}>逐题精讲－视频解析</p>
          <div className={style.ctqaContent}>
            <div className={style.ctqaImg}>
              <img src={require('./zhike-logo.svg')} className={style.zhikeLogo}/>
              <p>
                <span className={style.examName}>{this.props.exam ? this.props.exam.toUpperCase() :''}</span>
                <span>逐题精讲</span>
              </p>
            </div>
            <p>{ctqa.name}</p>
            <p>视频时长： {formatTime(ctqa.duration)}</p>
            <a
              className={style.goLook}
              onClick={() => this.clickLook()}
              target="_blank"
              >
              观看
            </a>
          </div>
        </div>
      )
    }
    return null;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Material/ExplainByTitle.js
 **/